export default __webpack_public_path__ + "static/media/iot_connections_card.9acfdb28.jpg";